export default {
  'memberList.1': 'IC Card Number',
  'memberList.2': 'Please enter IC card number',
  'memberList.3': 'Please enter your cell phone number',
  'memberList.4': 'Apply for a card',
  'memberList.5': 'Member Status',
  'memberList.6': 'Please select membership status',
  'memberList.7': 'Applets',
  'memberList.9': 'Registration Source',
  'memberList.10': 'Please select the source of registration',
  'memberList.11': 'App Registration',
  'memberList.14': 'User List',
  'memberList.15': 'Disposal of the difference',
  'memberList.17': 'Registration Time',
  'memberList.18': 'Tied card time',
  'memberList.19': 'Available Balance',
  'memberList.20': 'Usable Environmental Value',
  'memberList.24': 'IC Card Open Up',
  'memberList.27': 'Equipment',
  'memberList.29': 'Data Input',
  'memberList.30': 'Customer login',
  'memberList.31': 'Recycling staff entry',
  'memberList.32': 'Are you sure',
  'memberList.33': 'This account',
  'memberList.34': 'Please enter the reason for disabling',
  'memberList.36': '请输入禁用/Please enter reason for disabling/enabling (required)',
  'memberList.37': 'Member of the data',
  'memberDetail.1': 'Basic Information',
  'memberDetail.2': 'Not on the list',
  'memberDetail.3': 'Usable Environmental Value',
  'memberDetail.4': 'Accumulated Environmental Credit',
  'memberDetail.5': 'Environment Credit Ranking',
  'memberDetail.6': 'Untie',
  'memberDetail.7': 'Face recognition image storage time',
  'memberDetail.8': 'No face recognition image yet',
  'memberDetail.9': 'Actual Name',
  'memberDetail.10': 'Identity number',
  'memberDetail.12': 'Sex',
  'memberDetail.13': 'Age',
  'memberDetail.14': 'Profession',
  'memberDetail.15': 'Address',
  'memberDetail.16': 'User behaviour',
  'memberDetail.17': 'Success',
  'memberDetail.18': 'APP appointment',
  'memberDetail.19': 'Pending order',
  'memberDetail.20': 'Recycled',
  'memberDetail.21': 'Completed',
  'memberDetail.22': 'Cancelled',
  'memberDetail.23': 'Expired',
  'memberDetail.24': 'Mall',
  'memberDetail.25': 'Spitting machine',
  'memberDetail.26': 'Alipay',
  'memberDetail.27': 'Exchange record',
  'memberDetail.28': 'Are you sure to unbind this integration card',
  'memberDetail.29': 'After unbinding, the points will be retained and this card will be invalid. Please operate with caution！',
  'memberDetail.30': 'Please enter the reason for unbinding（Required）',
  'memberDetail.31': 'Full display',
  'memberDetail.32': 'Member Registration Time',
  'memberDetail.33': 'Recent Login Time',
  'memberDetail.34': 'Disposal Record',
  'memberDetail.35': 'Withdrawal record',
  'memberDetail.36': 'Environmental Credit  Record',
  'memberDetail.37': 'Balance record',
  'memberDetail.38': 'Reserved Recycling Record',
  'memberDetail.39': 'Recharge record',
  'memberDetail.40': 'Withdrawals record',
  'memberDetail.41': 'Creation time',
  'memberDetail.42': 'Unbind record',
  'memberDetail.43': 'Post photos',
  'memberDetail.44': 'Order number',
  'memberDetail.45': 'Delivery area',
  'memberDetail.46': 'device ID',
  'memberDetail.47': 'Delivery time',
  'memberDetail.48': 'Delivery type',
  // 'memberDetail.49': '重量(Kg)',
  'memberDetail.50': 'Add balance',
  'memberDetail.51': 'Add Environmental Credit',
  'memberDetail.52': 'Status',
  'memberDetail.53': 'Withdrawal community',
  'memberDetail.54': 'Withdrawal to account channels',
  'memberDetail.55': 'Withdrawal time',
  'memberDetail.56': 'Withdrawal amount（RMB）',
  'memberDetail.57': 'Exchange channels',
  'memberDetail.58': 'Redemption Commodity',
  'memberDetail.59': 'Redemption Time',
  'memberDetail.60': 'Redemption Credit (Environmental Credit)',
  'memberDetail.61': 'Appointment method',
  'memberDetail.62': 'Transaction Serial',
  'memberDetail.63': 'Time',
  'memberDetail.64': 'Environmental Credit',
  'memberDetail.65': 'Usable Environmental Value',
  'memberDetail.66': 'Type',
  'memberDetail.67': 'Remarks',
  'memberDetail.68': 'Balance',
  'memberDetail.69': 'Remaining balance amount',
  'memberDetail.70': 'Make an appointment for recycling',
  'memberDetail.80': 'Order Status',
  'memberDetail.81': 'Recharge order number',
  'memberDetail.82': 'Recharge time',
  'memberDetail.83': 'Recharge channels',
  'memberDetail.84': 'Recharge amount（RMB）',
  'memberDetail.85': 'Withdraw order number',
  'memberDetail.86': 'Withdrawal completion time',
  'memberDetail.87': 'Withdrawal amount（RMB）',
  'memberDetail.88': 'Service fee（RMB）',
  'memberDetail.89': 'IC Card Number',
  'memberDetail.90': 'Identity address',
  'memberDetail.91': 'Please enter the user\'s real name',
  'memberDetail.92': 'Store',
  'memberDetail.93': 'WeCha',
  'memberDetail.94': 'Account operational',
  'memberDetail.95': 'Add record',
  'memberDetail.96': 'Operator',
  'memberDetail.97': 'Add an operations record',
  'memberDetail.98': 'Event name',
  'memberDetail.99': 'Fill in the event name',
  'memberDetail.100': 'Fill in the name of the event, such as: complaint return visit, exception handling, etc.',
  'memberDetail.101': 'Please fill in the remarks',
  'memberDetail.102': 'Untie the card record',
  'memberDetail.103': 'Appointment time',
  'memberDetail.104': 'Member information modified successfully',
  'memberDetail.105': 'Unbind successfully',
  'memberDetail.106': 'Add an operations record',
  'memberDiff.1': 'Disposal of User Funds',
  'memberDiff.2': 'Card fees deducted',
  'memberDiff.3': 'Please select card number',
  'memberDiff.4': 'Amount deducted',
  'memberDiff.5': 'Please fill in the deduction amount',
  'memberDiff.6': 'Please fill in the card fee deduction remarks',
  'memberDiff.7': 'Fund disposal',
  'memberDiff.8': 'Associated number',
  'memberDiff.9': 'Disposal type',
  'memberDiff.10': 'Delivery uncounted replenishment',
  'memberDiff.11': 'Deductions for delivery violations',
  'memberDiff.12': 'Type of change',
  'memberDiff.13': 'Amount',
  'memberDiff.14': 'Integral',
  'memberDiff.15': 'Disposal amount',
  'memberDiff.16': 'Please fill in the disposal amount',
  'memberDiff.17': 'Please fill in the actual amount, not exceeding the withdrawal amount',
  'memberDiff.18': 'Please fill in the reason for disposal',
  'memberDiff.19': 'Product name',
  'memberDiff.20': 'Total payment amount',
  'memberDiff.21': 'Payment Method',
  'memberDiff.22': 'Whether to pay in full',
  'memberDiff.23': 'Amount owed（RMB）',
  'memberDiff.24': 'User Name',
  'memberDiff.25': 'Redeem mobile phone number',
  'memberDiff.26': 'Redemption Time',
  'memberDiff.27': 'Abnormal replenishment of coin spit',
  'memberDiff.28': 'Recycling category',
  'memberDiff.29': 'Please select the recycling category',
  'memberDiff.30': 'The minimum disposal amount is',
  'memberDiff.31': 'Please fill in the actual amount',
  'memberDiff.32': 'Recycling list',
  'memberDiff.33': 'Difference disposal record',
  'memberDiff.34': 'Disposal records',
  'memberDiff.35': 'Recovery time',
  'memberDiff.36': 'Recycling staff',
  'memberDiff.37': 'Total recovery',
  'memberDiff.38': 'Kitchen Waste Collection Staff',
  'memberDiff.39': 'Valuation method',
  'memberDiff.40': 'In terms of weight',
  'memberDiff.41': 'Would valuation',
  'memberDiff.42': 'Unit price',
  'memberDiff.43': 'Add points',
  'memberDiff.44': 'Recycled',
  'memberDiff.45': 'Total',
  'memberDiff.46': 'Sorry the disposal amount cannot be negative',
  'memberDiff.47': 'Sorry, I can\'t integrate into a decimal',
  'memberDiff.48': 'Sorry, the maximum integral is 2000',
  'memberDiff.49': 'Sorry, the maximum amount of this order is',
  'memberDiff.50': 'Sorry, the maximum amount is 20',
  'memberDiff.51': 'The exchange machine is less shipped and added',
  'memberDiff.52': 'Deductions for multiple shipments of exchange machines',
  'memberDiff.53': 'Fixed point retrievable records',
  'memberDiff.54': 'Fixed Location Kitchen Waste Record',
  'memberDiff.55': 'Card fee deducted successfully',
  'memberDiff.56': 'Successful disposal of funds',
  'memberDiff.57': 'Fixed point recoverable undercount is added',
  'memberDiff.58': 'Fixed point recoverable multiple deductions',
  'memberDiff.59': 'Food waste recycling under-rated supplement',
  'memberDiff.60': 'Excess deduction for kitchen waste recovery',
  'memberDiff.61': 'Fixed point recoverable undercount is added',
  'memberDiff.62': 'Fixed-point recyclable multiple deductions',
  'memberImport.1': 'Tied card time',
  'memberImport.2': 'Imported user list',
  'memberImport.3': 'Add Single user',
  'memberImport.4': 'Batch Import',
  'memberImport.5': 'Member import',
  'memberImport.6': 'Applicable area',
  'memberImport.7': 'Please select the applicable area',
  'memberImport.8': 'Please fill in the user name',
  'memberImport.9': 'Please fill in your phone number',
  'memberImport.10': 'Please select province/district/street',
  'memberImport.11': 'Please select a community',
  'memberImport.12': 'Building number',
  'memberImport.13': 'Please fill in the building number',
  'memberImport.14': 'Unit number',
  'memberImport.15': 'Please fill in the unit number',
  'memberImport.16': 'Please fill in the house number',
  'memberImport.17': 'Fill in the information of the imported member',
  'memberImport.18': 'Prepare the imported data in the format of the data template. The header name in the template cannot be changed and the header row cannot be deleted',
  'memberImport.19': 'Download the template',
  'memberImport.20': 'Upload the completed member information form',
  'memberImport.21': 'Upload suffix name must be xls or xlsx (that is, excel format), file ≤ 10M',
  'memberImport.22': 'Upload files',
  'memberImport.23': 'Renewal Time',
  'memberImport.24': 'House number',
  'memberImport.25': 'Hong Kong, Macau and Taiwan',
  'memberImport.26': 'Successful entry',
  'memberImport.27': 'Sorry, please select the area first',
  'memberImport.28': 'Upload file size cannot exceed 10MB!',
  'memberImport.29': 'Please select Excel file to upload!',
  'memberImport.30': 'Please select a file to upload!',
  'memberImport.31': 'Please fill in the correct contact number',
  'memberImport.32': 'Mainland',
  'memberImport.33': 'Fill in the information for import collection',
  'memberImport.34': 'Upload the completed collection information form',
  'memberFamily.1': 'Family list',
  'memberFamily.2': 'Family members',
  'memberFamily.3': 'Home user information editing',
  'memberFamily.4': 'Family information',
  'memberFamily.5': 'Number of family members',
  'memberFamily.6': 'Number of family members',
  'memberFamily.7': 'member',
  'memberFamily.8': 'Member information',
  'memberFamily.9': 'Successfully modified',
  'cardRecord.1': 'Card applicants',
  'cardRecord.2': 'Please enter the person\'s name or mobile phone number',
  'cardRecord.3': 'Card time',
  'cardRecord.4': 'Handle card records',
  'cardRecord.5': 'Only show the card application data generated after September 2020, including APP and background card application, the current number of card applications',
  'cardRecord.6': 'Card status query',
  'cardRecord.7': 'Please enter the card number to query',
  'cardRecord.8': 'Mobile phone number of the person applying for the card',
  'cardRecord.9': 'The card is in use',
  'cardRecord.10': 'This card has been invalidated',
  'cardRecord.11': 'This card is not yet bound',
  'cardRecord.12': 'Card application record'
}
